<template>
  <div class="content_box">
    <div class="content_box_inner">
      <div class="headTitle">
        <img src="@/assets/imgs/icon/icon_garden.png" alt />
        园区库
      </div>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="所在区县：" style="margin-right: 30px">
          <el-select
            v-model="searchObj.seat"
            clearable
            placeholder="请选择所在区县"
            filterable
          >
            <el-option label="不限" value></el-option>
            <el-option
              v-for="item in seatList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="园区名称：" style="margin-right: 30px">
          <el-input
            v-model="searchObj.name"
            placeholder="请输入园区名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="园区类别：">
          <el-select
            v-model="searchObj.type"
            clearable
            placeholder="请选择园区类别"
          >
            <el-option label="不限" value></el-option>
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSearch"
            class="bg5584FF formBotton"
            style="margin-left: 40px"
            >查询</el-button
          >
          <el-button type="info" @click="onReset" class="formBotton"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <hr />
      <el-button type="primary" size="small" class="bg5584FF" @click="addNew">
        <i class="el-icon-plus"></i> 新增园区
      </el-button>
      <div style="height: 20px"></div>
      <el-table
        :data="gardenList"
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
        v-loading="loading"
      >
        <!-- <el-table-column align="center" type="index" width="200" label="排序"></el-table-column> -->
        <el-table-column prop="name" label="园区名称" fixed>
          <template slot-scope="scope">
            <span @click="detail(scope.row)" class="canClick">{{
              scope.row.name
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="seat" label="所在区县"></el-table-column>
        <el-table-column prop="level" label="园区级别"></el-table-column>
        <el-table-column prop="type" label="园区类型"></el-table-column>
        <el-table-column prop="contacts" label="联系人"></el-table-column>
        <el-table-column prop="phone" label="联系电话"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              class="MR18 bg5584FF"
              type="primary"
              @click="editGarden(scope.row)"
              >编辑</el-button
            >
            <!-- <el-button
            size="mini"
            class="MR18 bg5584FF"
            type="primary"
            @click="deleteGarden(scope.row)"
          >删除</el-button>-->
            <el-button
              size="mini"
              class="MR18 green"
              type="primary"
              @click="useGarden(scope.row)"
              v-if="scope.row.state == 1"
              >启用</el-button
            >
            <el-button
              size="mini"
              class="MR18 red"
              type="primary"
              @click="stopGarden(scope.row)"
              v-else
              >停用</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBox">
        <el-pagination
          class="pagePC"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          layout="total,  prev, pager, next"
          :total="totalNum"
        >
        </el-pagination>
        <van-pagination
          class="pagePhone"
          v-model="currentPage"
          :total-items="totalNum"
          :items-per-page="10"
          :show-page-size="3"
          @change="changePage"
          force-ellipses
        />
      </div>
      <!-- 新增弹框 -->
      <el-dialog
        title="新增园区"
        :visible.sync="showAddWindow"
        class="titleChange bodyScroll"
        :width="screenWidth < 1200 ? '94%' : '800px'"
        :close-on-click-modal="false"
        :before-close="closeAddGarden"
      >
        <div class="lineTitle">基本信息</div>
        <el-form
          :inline="true"
          :model="addObj"
          class="demo-form-inline half"
          size="mini"
          label-width="100px"
          label-position="right"
          ref="addForm"
          :rules="rules"
          v-loading="addLoading"
        >
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="园区名称" prop="name">
                <el-input v-model="addObj.name" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="园区类型">
                <el-select v-model="addObj.type" clearable placeholder="请选择">
                  <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="园区级别">
                <el-select
                  v-model="addObj.level"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in levelList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="园区规模">
                <el-select
                  v-model="addObj.scale"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in scaleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所在区县" prop="seat">
                <el-select
                  v-model="addObj.seat"
                  clearable
                  placeholder="请选择"
                  filterable
                >
                  <el-option
                    v-for="item in seatList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item label="园区主导产业" prop="industry">
                <el-input
                  class="address_input_box"
                  type="textarea"
                  v-model="addObj.industry"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item
                class="address_input_box"
                label="园区简介"
                prop="introduction"
              >
                <el-input
                  type="textarea"
                  v-model="addObj.introduction"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <hr style="width: 100%; margin: 30px 0" />
          <div class="lineTitle" style="width: 100%">联系信息</div>
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系人姓名" prop="contacts">
                <el-input
                  v-model="addObj.contacts"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系人职务">
                <el-input v-model="addObj.post" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系手机" prop="phone">
                <el-input
                  v-model="addObj.phone"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系座机" prop="landline">
                <el-input
                  v-model="addObj.landline"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系邮箱">
                <el-input
                  v-model="addObj.email"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item style="width: 100%; text-align: center">
            <div class="btnBox">
              <el-button
                type="primary"
                size="mini"
                class="bg5584FF"
                @click="sureAdd"
                >新增</el-button
              >
              <el-button type="normal" size="mini" @click="closeAddBtn"
                >取消</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 编辑弹框 -->
      <el-dialog
        title="编辑园区"
        :visible.sync="showEditWindow"
        :width="screenWidth < 1200 ? '94%' : '800px'"
        class="titleChange bodyScroll"
        :close-on-click-modal="false"
      >
        <div class="lineTitle">基本信息</div>
        <el-form
          :inline="true"
          :model="editObj"
          class="demo-form-inline half"
          size="mini"
          label-width="100px"
          label-position="right"
          ref="editForm"
          :rules="editRules"
          v-loading="editLoading"
        >
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="园区名称" prop="name">
                <el-input
                  v-model="editObj.name"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="园区代码">
                <el-input
                  v-model="editObj.code"
                  placeholder="自动生成"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="园区类型">
                <el-select
                  v-model="editObj.type"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="园区级别">
                <el-select
                  v-model="editObj.level"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in levelList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="园区规模">
                <el-select
                  v-model="editObj.scale"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in scaleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所在区县" prop="seat">
                <el-select
                  v-model="editObj.seat"
                  clearable
                  placeholder="请选择"
                  filterable
                >
                  <el-option
                    v-for="item in seatList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item label="园区主导产业" prop="industry">
                <el-input
                  class="address_input_box"
                  type="textarea"
                  v-model="editObj.industry"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item
                class="address_input_box"
                label="园区简介"
                prop="introduction"
              >
                <el-input
                  type="textarea"
                  v-model="editObj.introduction"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <hr style="width: 100%; margin: 30px 0" />
          <div class="lineTitle" style="width: 100%">联系信息</div>
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系人姓名" prop="contacts">
                <el-input
                  v-model="editObj.contacts"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系人职务">
                <el-input
                  v-model="editObj.post"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系手机" prop="phone">
                <el-input
                  v-model="editObj.phone"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系座机" prop="landline">
                <el-input
                  v-model="editObj.landline"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系邮箱">
                <el-input
                  v-model="editObj.email"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item style="width: 100%; text-align: center">
            <div class="btnBox">
              <el-button
                type="primary"
                size="mini"
                class="bg5584FF"
                @click="sureEdit"
                >保存</el-button
              >
              <el-button
                type="normal"
                size="mini"
                @click="showEditWindow = false"
                >取消</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 查看详情弹框 -->
      <el-dialog
        title="园区详情"
        :visible.sync="showCheckWindow"
        :width="screenWidth < 1200 ? '94%' : '800px'"
        class="titleChange bodyScroll"
        :close-on-click-modal="false"
      >
        <div class="lineTitle">基本信息</div>
        <el-form
          :inline="true"
          :model="checkObj"
          class="demo-form-inline half"
          size="mini"
          label-width="100px"
          label-position="left"
        >
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="园区名称" prop="name">
                <el-input v-model="checkObj.name" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="园区代码">
                <el-input
                  v-model="checkObj.code"
                  placeholder="自动生成"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="园区类型">
                <el-select v-model="checkObj.type" clearable disabled>
                  <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="园区级别">
                <el-select v-model="checkObj.level" clearable disabled>
                  <el-option
                    v-for="item in levelList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="园区规模">
                <el-select v-model="checkObj.scale" disabled>
                  <el-option
                    v-for="item in scaleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所在区县" prop="seat">
                <el-select v-model="checkObj.seat" disabled filterable>
                  <el-option
                    v-for="item in seatList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item label="园区主导产业">
                <el-input
                  class="address_input_box"
                  type="textarea"
                  v-model="checkObj.industry"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item label="园区简介">
                <el-input
                  class="address_input_box"
                  type="textarea"
                  v-model="checkObj.introduction"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <hr style="width: 100%; margin: 30px 0" />
          <div class="lineTitle" style="width: 100%">联系信息</div>
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系人姓名" prop="contacts">
                <el-input v-model="checkObj.contacts" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系人职务">
                <el-input v-model="checkObj.post" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系手机">
                <el-input v-model="checkObj.phone" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系座机">
                <el-input v-model="checkObj.landline" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系邮箱">
                <el-input v-model="checkObj.email" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
import { mapGetters } from "vuex";
export default {
  data() {
    var checkNum = (rule, value, callback) => {
      if (value) {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var checkGardenName = (rule, value, callback) => {
      this.$axios
        .post("/business/park/checkParkName", { name: value })
        .then((res) => {
          if (res.data == 0) {
            callback();
          } else {
            callback(new Error("园区名已存在"));
          }
        });
    };
    var checkUpdateGardenName = (rule, value, callback) => {
      this.$axios
        .post("/business/park/checkUpdateParkName", {
          name: value,
          id: this.nowId,
        })
        .then((res) => {
          if (res.data == 0) {
            callback();
          } else {
            callback(new Error("园区名已存在"));
          }
        });
    };

    var checkLength = (rule, value, callback) => {
      if (value) {
        if (value.length > 150) {
          callback(
            new Error("输入长度限制为150字符，当前输入长度" + value.length)
          );
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽
      screeHeight: document.body.clientHeight, // 屏幕高
      searchObj: {
        seat: "",
        name: "",
        type: "",
      },
      gardenList: [],
      addObj: {
        name: "",
        type: "",
        level: "",
        scale: "",
        seat: "",
        industry: "",
        introduction: "",
        contacts: "",
        post: "",
        phone: "",
        landline: "",
        email: "",
      },
      editObj: {
        name: "",
        code: "",
        type: "",
        level: "",
        scale: "",
        seat: "",
        industry: "",
        introduction: "",
        contacts: "",
        post: "",
        phone: "",
        landline: "",
        email: "",
      },
      checkObj: {
        name: "",
        code: "",
        type: "",
        level: "",
        scale: "",
        seat: "",
        industry: "",
        introduction: "",
        contacts: "",
        post: "",
        phone: "",
        landline: "",
        email: "",
      },
      currentPage: 1,
      showAddWindow: false,
      showEditWindow: false,
      showDeleteWindow: false,
      showCheckWindow: false,
      totalNum: 0,
      addLoading: false,
      editLoading: false,
      pageObj: {},
      // seatList: [],
      typeList: [],
      scaleList: [],
      levelList: [],
      loading: false,
      nowId: "",
      rules: {
        name: [
          { required: true, message: "请填写园区名称", trigger: "blur" },
          { validator: checkGardenName, trigger: "blur" },
        ],
        seat: [
          { required: true, message: "请选择园所在区县", trigger: "blur" },
        ],
        contacts: [
          { required: true, message: "请填写联系人名称", trigger: "blur" },
        ],
        phone: [{ validator: checkNum, trigger: "blur" }],
        landline: [{ validator: checkNum, trigger: "blur" }],
        introduction: [{ validator: checkLength, trigger: "change" }],
        industry: [{ validator: checkLength, trigger: "change" }],
      },
      editRules: {
        name: [
          { required: true, message: "请填写园区名称", trigger: "blur" },
          { validator: checkUpdateGardenName, trigger: "blur" },
        ],
        seat: [
          { required: true, message: "请选择园所在区县", trigger: "blur" },
        ],
        contacts: [
          { required: true, message: "请填写联系人名称", trigger: "blur" },
        ],
        phone: [{ validator: checkNum, trigger: "blur" }],
        landline: [{ validator: checkNum, trigger: "blur" }],
        introduction: [{ validator: checkLength, trigger: "change" }],
        industry: [{ validator: checkLength, trigger: "change" }],
      },
    };
  },
  methods: {
    onSearch() {
      this.getGardenList({ pageNum: 1, pageSize: 10 }, this.searchObj);
    },
    onReset() {
      this.getGardenList({ pageNum: 1, pageSize: 10 });
      this.currentPage = 1;
      this.searchObj = {
        seat: "",
        name: "",
        type: "",
      };
    },
    detail(row) {
      this.checkObj = row;
      this.showCheckWindow = true;
    },
    addNew() {
      this.showAddWindow = true;
    },
    sureAdd() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          this.$axios
            .post("/business/park/insertParkInfo", this.addObj)
            .then((res) => {
              Message.success("新增成功");
              this.addLoading = false;
              this.showAddWindow = false;
              this.getGardenList({ pageNum: 1, pageSize: 10 });
              this.currentPage = 1;
              this.resetAddForm();
              console.log("新增成功", res);
            })
            .catch((res) => {
              this.addLoading = false;
              console.log("新增失败", res);
            });
        } else {
          Message.error("请完善表单信息");
          return false;
        }
      });
    },
    resetAddForm() {
      this.addObj = {
        name: "",
        type: "",
        level: "",
        scale: "",
        seat: "",
        industry: "",
        introduction: "",
        contacts: "",
        post: "",
        phone: "",
        landline: "",
        email: "",
      };
      this.$refs.addForm.resetFields();
    },
    closeAddGarden(done) {
      this.resetAddForm();
      done();
    },
    closeAddBtn() {
      this.resetAddForm();
      this.showAddWindow = false;
    },
    editGarden(row) {
      this.editObj = JSON.parse(JSON.stringify(row));
      this.nowId = row.id;
      this.showEditWindow = true;
    },
    sureEdit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          this.$axios
            .put("/business/park/updateParkInfo", this.editObj)
            .then((res) => {
              Message.success("修改成功");
              this.editLoading = false;
              this.showEditWindow = false;
              this.onReset();
              console.log("修改成功", res);
            })
            .catch((res) => {
              this.editLoading = false;
              console.log("修改失败", res);
            });
        } else {
          Message.error("请完善表单信息");
          return false;
        }
      });
    },
    // deleteGarden() {
    //   this.showDeleteWindow = true;
    // },
    useGarden(row) {
      this.$axios
        .put("/business/park/updateState", {
          id: row.id,
          state: 0,
          code: row.code,
        })
        .then(() => {
          this.getGardenList({ pageNum: 1, pageSize: 10 });
        })
        .catch((res) => {
          console.log("启用结果失败信息", res);
        });
    },
    stopGarden(row) {
      this.$axios
        .put("/business/park/updateState", {
          id: row.id,
          state: 1,
          code: row.code,
        })
        .then(() => {
          this.getGardenList({ pageNum: 1, pageSize: 10 });
        })
        .catch((res) => {
          console.log("停用结果失败信息", res);
        });
    },
    // sureDelete() {},
    handleSizeChange() {},
    changePage() {
      this.pageNum = this.currentPage;
      this.getGardenList(
        { pageNum: this.currentPage, pageSize: 10 },
        this.searchObj
      );
    },
    handleCurrentChange(current) {
      this.getGardenList({ pageNum: current, pageSize: 10 }, this.pageObj);
    },
    // 获取列表
    getGardenList(pageObj, searchObj) {
      this.loading = true;
      let pms = Object.assign(pageObj, searchObj);
      this.$axios
        .get("/business/park/list", { params: pms })
        .then((res) => {
          this.gardenList = res.data;
          this.totalNum = res.total;
          this.pageObj = searchObj;
          this.loading = false;
        })
        .catch((res) => {
          console.log("园区列表获取失败", res);
          this.loading = false;
        });
    },
    // 获取下拉框选项
    getSelectList() {
      // 园区级别
      this.$axios
        .get("/business/park/Level")
        .then((res) => {
          this.levelList = res.data;
        })
        .catch((res) => {
          console.log("园区级别列表获取失败", res);
        });
      // 园区规模
      this.$axios
        .get("/business/park/scale")
        .then((res) => {
          this.scaleList = res.data;
        })
        .catch((res) => {
          console.log("园区规模获取失败", res);
        });

      // 园区类型
      this.$axios
        .get("/business/park/type")
        .then((res) => {
          this.typeList = res.data;
        })
        .catch((res) => {
          console.log("园区类型列表获取失败", res);
        });
    },
  },
  created() {
    console.log(this.seatList);
    this.getGardenList({ pageNum: 1, pageSize: 10 });
    this.getSelectList();
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
  },
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
    }),
  },
};
</script>
<style lang="less" scoped>
hr {
  border-color: rgba(155, 155, 155, 0.2);
  margin: 10px 0 20px;
}
.content_box {
  padding: 20px 30px 30px;
}

.content_box_inner {
  padding: 10px 20px 20px;
  box-shadow: 0px 0px 50px #ccc;
}
.pagePhone {
  display: none;
}

@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
  .content_box_inner {
    padding: 10px 10px 20px;
  }
  .pagePC {
    display: none;
  }
  .pagePhone {
    display: flex;
  }
}
</style>


